import React from 'react';

import { RecordContextProvider, useRecordContext } from 'react-admin';

import { get } from 'lodash';

import StatusField from '../../../customFields/StatusField';
import DiffFieldLayout from './DiffFieldLayout';

const StatusDiffField = ({
  source,
  label,
  resource,
}: {
  source: string;
  label: string;
  resource?: string;
}) => {
  const record = useRecordContext();

  const oldValue = get(record, `${source}.oldRawValue`);
  const newValue = get(record, `${source}.newRawValue`);

  return (
    <DiffFieldLayout
      label={label}
      oldElement={(
        <RecordContextProvider value={oldValue ? { value: oldValue } : {}}>
          <StatusField source="value" resource={resource} />
        </RecordContextProvider>
      )}
      newElement={(
        <RecordContextProvider value={newValue ? { value: newValue } : {}}>
          <StatusField source="value" resource={resource} />
        </RecordContextProvider>
      )}
    />
  );
};

export default StatusDiffField;
